import _ from 'lodash';
import * as stateManagement from '#packages/stateManagement';
import * as coreBi from '#packages/coreBi';
import constants from '#packages/constants';
import type { EditorAPI } from '#packages/editorAPI';

const { translateToViewerCoordinates } =
  stateManagement.domMeasurements.selectors;
let selectedComponent;
let editorAPI: EditorAPI;
let isPage;
let gapKey: string;
let lastUpdatedGap: number;
let initialGap: number;
let initialMouseY: number;

function startDrag(_editorAPI: EditorAPI, params: AnyFixMe) {
  editorAPI = _editorAPI;
  selectedComponent = params.comps;
  isPage = editorAPI.components.is.page(selectedComponent);

  //@ts-expect-error
  const gaps = editorAPI.siteSegments.getGaps();
  gapKey = isPage ? 'headerToPagesGap' : 'pagesToFooterGap';
  initialGap = gaps[gapKey] || 0;

  const mouseCoordinates = translateToViewerCoordinates(editorAPI, params.evt);
  initialMouseY = mouseCoordinates.relativeToSite.y;
}

function onDrag(event: AnyFixMe) {
  const mouseCoordinates = translateToViewerCoordinates(editorAPI, event);
  const mouseDiff = initialMouseY - mouseCoordinates.relativeToSite.y;
  const newGap = _.max([0, initialGap - mouseDiff]);
  const updatedGap = _.set({}, gapKey, newGap);

  lastUpdatedGap = newGap;
  //@ts-expect-error
  editorAPI.siteSegments.updateGaps(updatedGap);
}

function endDrag(event: AnyFixMe) {
  const mouseCoordinates = translateToViewerCoordinates(editorAPI, event);

  if (mouseCoordinates.relativeToSite.y < initialMouseY) {
    editorAPI.bi.event(coreBi.events.editBox.DRAG_GAP, {
      gap_type: gapKey,
      gap_size_start: initialGap,
      gap_size_end: lastUpdatedGap,
    });
    editorAPI.history.add('gap updated');
  }
}

export default {
  start: startDrag,
  on: onDrag,
  end: endDrag,
  //@ts-expect-error
  type: constants.MOUSE_ACTION_TYPES.CLOSE_GAPS,
};
